import * as React from "react";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { inject } from "mobx-react";
import { ContextStore } from "bernie-core";
import { useLocalization } from "@shared-ui/localization-context";
import { ratingDescription } from "../hotelRecentReviewsUtils";
import { UitkText } from "uitk-react-text";

interface ReviewTitleAndRatingProps {
  context?: ContextStore;
  rating: string;
  reviewTitle?: string;
  showReviewSuperlative?: boolean;
}

const ReviewTitleAndRating = (props: ReviewTitleAndRatingProps) => {
  const { formatText } = useLocalization();
  const ratingText = formatText("hotelRecentReviews.outOf5Rating", props.rating);
  const reviewText = props.showReviewSuperlative ? `${ratingText} ${ratingDescription(props.rating)}` : ratingText;

  return (
    <Viewport>
      <ViewSmall>
        <div className="uitk-cell all-y-padding-one">
          <UitkText overflow="truncate-2-lines" size={500} className="uitk-type-heading-500">
            {props.reviewTitle || formatText("hotelRecentReviews.verifiedBrandReview", props.context!.site.name)}
          </UitkText>
          <div>{reviewText}</div>
        </div>
      </ViewSmall>
      <ViewMedium>
        <div className="uitk-cell all-y-padding-one">
          <UitkText overflow="truncate-2-lines" size={500} className="uitk-type-heading-500">
            {props.reviewTitle || formatText("hotelRecentReviews.verifiedBrandReview", props.context!.site.name)}
          </UitkText>
          <div className="reviewRating uitk-type-medium uitk-type-300">{reviewText}</div>
        </div>
      </ViewMedium>
    </Viewport>
  );
};

export default inject("context")(ReviewTitleAndRating);
